export enum APP_VARIANTS_ENUM {
  CORE_SELECTION = "core-selection",
  FINISHING_GUIDE = "finishing-guide",
}

export type AppVariantType = "core-selection" | "finishing-guide";
export interface AppSettingsType {
  applicationRoot: Element;
  appVariant: AppVariantType;
  filterDataUrl: string;
  productResultsUrl: string;
  compareApiUrl: string;
  inquiryApiUrl: string;
  errMessage: string;
}
